













































































import { Component, Mixins } from "vue-property-decorator";
import { PromptTemplate } from "@/views/biaggregate/types";
import {
  BiaggregateAisummaryConfiguration,
  DefaultBiaggregateAisummaryConfiguration,
} from "#/model/biaggregate";
import AxiosMixin from "@/mixins/axiosMixin";
import UserMixin from "@/mixins/userMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";

@Component({
  components: {
    AppAuthButton,
  },
})
export default class extends Mixins(AxiosMixin, UserMixin) {
  /** 集計AIサマリプロンプトテンプレート(一覧表示用) */
  private promptTemplates: PromptTemplate[] = [];

  /** 集計AIサマリ設定 */
  private configuration: BiaggregateAisummaryConfiguration =
    DefaultBiaggregateAisummaryConfiguration();

  /** データテーブル用ヘッダー */
  private headers = [
    {
      text: "",
      value: "actions",
      sortable: false,
      align: "end",
      width: "200px",
    },
    {
      text: "有効",
      value: "is_valid",
      sortable: true,
      filterable: false,
      align: "start",
      width: "80px",
    },
    {
      text: "設定名",
      align: "start",
      value: "name",
      width: "200px",
      filterable: true,
      sortable: false,
    },
    {
      text: "コメント",
      align: "start",
      value: "comment",
      width: "200px",
      filterable: true,
      sortable: false,
    },
    {
      text: "AI種類",
      align: "start",
      value: "llm_type_name",
      sortable: true,
      filterable: false,
      width: "120px",
    },
    {
      text: "モデル名",
      align: "start",
      value: "model_name",
      sortable: true,
      filterable: false,
      width: "180px",
    },
    {
      text: "最終更新日時",
      align: "start",
      value: "updated_at_str",
      sortable: true,
      filterable: false,
      width: "140px",
    },
    {
      text: "最終更新者",
      align: "start",
      value: "editor_admin_name",
      sortable: true,
      filterable: false,
      width: "140px",
    },
  ];

  /** フィルター用キーワード */
  private searchKeyword = "";

  /** 1ページあたりの表示件数 */
  private itemPerPage = 25;

  /** 表の現在のページ数 */
  private pageNo = 1;

  created() {
    this.fetch();
  }

  /** 取得 */
  private fetch() {
    this.postJsonCheck(
      window.base_url + "/api/admin/biaggregate/aisummary/configuration/get",
      {},
      async (res) => {
        this.promptTemplates = res.data.prompt_templates;
        this.configuration = res.data.configuration;
      }
    );
  }

  /** AI設定保存 */
  private async saveConfiguration(promptTemplateId: number) {
    // 選択中の設定を再クリックした場合は何もしない
    if (
      promptTemplateId ===
      this.configuration.biaggregate_aisummary_prompt_template_id
    ) {
      return;
    }
    if (!(await this.$openConfirm("有効な生成AI設定を切り替えますか？"))) {
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/biaggregate/aisummary/configuration/save",
      {
        configuration: {
          ...this.configuration,
          biaggregate_aisummary_prompt_template_id: promptTemplateId,
        },
      },
      () => {
        this.fetch();
      }
    );
  }

  /** 表のページ変更 */
  private changePage(pageNo: number) {
    this.pageNo = pageNo;
  }

  /** 編集画面へ遷移 */
  private moveEditPage(id: number, isCopy = false) {
    this.$router.push({
      path: `/biaggregate/aisummary/prompt/edit/${id}`,
      query: { mode: isCopy ? "copy" : "edit" },
    });
  }
}
